import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Badge,
  Button,
  Card,
  Flex,
  Space,
  Group,
  Text,
  TextInput,
  SegmentedControl,
} from "@mantine/core";

import { PaginatedList } from "@components/shared";

export default function QuestionList({
  items = [],
  requestInfo = {
    url: `/retrieve-questions/`,
    data: {},
  },
  refresh,
  isIndex,
}) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    status: "1",
    search_value: "",
    variety: "1",
  });

  const reqData = {
    ...filters,
    ...requestInfo.data,
    refresh,
  };

  return (
    <div>
      {requestInfo && (
        <React.Fragment>
          <TextInput
            placeholder={t("search")}
            size="lg"
            value={filters.search_value}
            onChange={(e) =>
              setFilters({ ...filters, search_value: e.target.value })
            }
          />
          <Flex gap="sm" direction={{ base: "column", sm: "row" }} mt="sm">
            <SegmentedControl
              data={[
                { label: t("active"), value: "1" },
                { label: t("inactive"), value: "2" },
              ]}
              value={filters.status}
              onChange={(value) => setFilters({ ...filters, status: value })}
              size="xs"
            />
            <SegmentedControl
              data={[
                { label: t("all"), value: "entire" },
                { label: "ClearScreen", value: "1" },
                { label: "360", value: "2" },
                { label: "Engagement", value: "3" },
              ]}
              value={filters.variety}
              onChange={(value) => setFilters({ ...filters, variety: value })}
              size="xs"
            />
          </Flex>
        </React.Fragment>
      )}
      <PaginatedList
        tableData={items}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            link_url: `/questions/${m.id}`,
          }))
        }
        displayFormatter={(item) => {
          return (
            <Card key={item.original.id}>
              <Group>
                <Text
                  c="dark"
                  fw={700}
                  component={Link}
                  to={`/questions/${item.original.id}`}
                >
                  {item.original.text}
                </Text>
              </Group>
              <Text size="sm">
                {item.original.multiple_choice
                  ? "Multiple Choice"
                  : item.original.true_false
                  ? "True/False"
                  : item.original.yes_no
                  ? "Yes/No"
                  : "Open Response"}
              </Text>
            </Card>
          );
        }}
      />
    </div>
  );
}
